<template>
  <span :class="`jqac2-vld-wrapper text-wrapper ${ valid == false ? 'error' : '' }`">
    <div data-jqac2-validation-hint="" class="validation-description" v-if="hint || required">
      <span class="validation_tooltip" style="display: none; opacity: 0; height: 60px;">
        {{ hint }}
        <div v-if="required == true">Pflichtfeld</div>
      </span>
    </div>
    <input type="text" :value="value" :class="`underline ${ valid == false ? 'error' : '' }`" :placeholder="label"></input>
  </span>
</template>
<script>

export default {
  props: ['value', 'label', 'hint', 'required', 'confirmValue'],
  data(){
    return {
      valid: null
    }
  },
  methods: {
    setInvalid(){
      this.valid = false
    },
    setValid(){
      this.valid = true
    }
  }
}

</script>